import { FC } from 'react';
import { EvaluationFilterType } from '@/pages/Millwrights/[ID]/hooks/useEvaluationFilters';
import { Button, Stack } from '@data-products-and-ai/react-components';

interface MillwrightEvaluationFiltersProps {
  filterType: EvaluationFilterType;
  onFilterChange: (filterType: EvaluationFilterType) => void;
}

export const MillwrightEvaluationFilters: FC<
  MillwrightEvaluationFiltersProps
> = ({ filterType = 'All', onFilterChange }) => {
  const handleFilterChange = (filterType: EvaluationFilterType) => () => {
    onFilterChange(filterType);
  };

  return (
    <Stack direction="row" horizontalAlign="center" gap={16}>
      <Button
        size="small"
        allCaps={false}
        type={filterType === 'All' ? 'primaryNoShadow' : 'primaryOutline'}
        onClick={handleFilterChange('All')}
      >
        All Outages
      </Button>
      <Button
        size="small"
        allCaps={false}
        type={filterType === 'Current' ? 'primaryNoShadow' : 'primaryOutline'}
        onClick={handleFilterChange('Current')}
      >
        Current Outage
      </Button>
    </Stack>
  );
};
